import { useParams } from "react-router-dom";
import { services } from "../data/servicesdata";

const ServiceDetail = () => {
  const { id } = useParams();
  const service = services.find((s) => s.id === id);

  if (!service) {
    return (
      <div className="text-center py-10 text-red-800">Service not found.</div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto py-12 px-4">
      <div className="bg-white border border-red-800 rounded-2xl p-8 shadow-lg mb-12">
        <div className="flex justify-center mb-6">{service.icon}</div>
        <h1 className="text-3xl font-bold text-red-800 text-center mb-4">
          {service.title}
        </h1>
        <p className="text-gray-700 text-center mb-6">{service.description}</p>
        <div className="text-sm text-gray-600">{service.details}</div>
      </div>

      {service.sections?.map((section, index) => (
        <div
          key={index}
          className="flex flex-col lg:flex-row gap-8 items-center mb-12"
        >
          {section.image && (
            <div className="lg:w-full">
              <img
                src={section.image}
                alt={section.title}
                className="rounded-xl shadow-md w-full h-auto"
              />
            </div>
          )}
          <div className="lg:w-full">
            <h2 className="text-2xl font-semibold text-red-800 mb-2">
              {section.title}
            </h2>
            <p className="text-gray-700 leading-relaxed">{section.content}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServiceDetail;
